/**
 *
 * @param duration
 */
export function getInterval(duration) {
    return duration.durationInterval;
}
/**
 *
 * @param duration
 */
export function getUnit(duration) {
    return duration.durationUnit;
}
/**
 *
 * @param duration
 */
export function getType(duration) {
    return duration.durationType;
}
